define("calendar/components/calendar/future-trends", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "moment", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _moment, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _class2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"moment",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.showFutureTrendsOnCalendar}}
    <div class="u--m__lr__md cCA--futureTrends" {{did-insert (perform this.loadData)}}>
      <Shared::Ui::Button
        @variant="unstyled"
        class={{concat-classes
          "cCA--futureTrends__button u--text--sm"
          (if this.needsUpgrade "cCA--futureTrends__button--disabled" "cCA--futureTrends__button--enabled")
        }}
      >
        {{svg-jar "hashtag" class="o--icon o--icon--sm"}}
        <span class="u--m__l__xs u--text--sm u--text--bold">
          {{t "calendar.future_trends.title"}}
        </span>
      </Shared::Ui::Button>
    </div>
    <Shared::Ui::EmberDrop
      @constrainToScrollParent={{false}}
      @constrainToWindow={{false}}
      @contentSelector=".cCA--futureTrends__body"
      @onClose={{this.closeDropdown}}
      @onOpen={{this.showDropdownOrModal}}
      @openOn="click"
      @position="bottom left"
      @target=".cCA--futureTrends__button"
      as |emberDrop|
    >
      <Calendar::FutureTrends::Body
        @closeAction={{emberDrop.closeAction}}
        @dateRangeFormatted={{this.dateRangeFormatted}}
        @isLoading={{this.isLoading}}
        @showFutureTrendsDropdown={{this.showFutureTrendsDropdown}}
        @todaysTopHashtags={{this.todaysTopHashtags}}
      />
      {{#if this.showTryFutureTrendsModal}}
        <Calendar::FutureTrends::TryModal
          @closeModal={{this.closeModal}}
          @showFutureTrends={{emberDrop.openAction}}
          @startTrial={{this.startFutureTrendsTrial}}
        />
      {{else if this.showUpgradeModal}}
        <Calendar::FutureTrends::UpgradeModal @closeModal={{this.closeUpgradeModal}} />
      {{/if}}
    </Shared::Ui::EmberDrop>
  {{/if}}
  */
  {
    "id": "Bh7TJQbV",
    "block": "[[[41,[30,0,[\"showFutureTrendsOnCalendar\"]],[[[1,\"  \"],[11,0],[24,0,\"u--m__lr__md cCA--futureTrends\"],[4,[38,1],[[28,[37,2],[[30,0,[\"loadData\"]]],null]],null],[12],[1,\"\\n    \"],[8,[39,3],[[16,0,[28,[37,4],[\"cCA--futureTrends__button u--text--sm\",[52,[30,0,[\"needsUpgrade\"]],\"cCA--futureTrends__button--disabled\",\"cCA--futureTrends__button--enabled\"]],null]]],[[\"@variant\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,5],[\"hashtag\"],[[\"class\"],[\"o--icon o--icon--sm\"]]]],[1,\"\\n      \"],[10,1],[14,0,\"u--m__l__xs u--text--sm u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,6],[\"calendar.future_trends.title\"],null]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[8,[39,7],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@onClose\",\"@onOpen\",\"@openOn\",\"@position\",\"@target\"],[false,false,\".cCA--futureTrends__body\",[30,0,[\"closeDropdown\"]],[30,0,[\"showDropdownOrModal\"]],\"click\",\"bottom left\",\".cCA--futureTrends__button\"]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,8],null,[[\"@closeAction\",\"@dateRangeFormatted\",\"@isLoading\",\"@showFutureTrendsDropdown\",\"@todaysTopHashtags\"],[[30,1,[\"closeAction\"]],[30,0,[\"dateRangeFormatted\"]],[30,0,[\"isLoading\"]],[30,0,[\"showFutureTrendsDropdown\"]],[30,0,[\"todaysTopHashtags\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"showTryFutureTrendsModal\"]],[[[1,\"      \"],[8,[39,9],null,[[\"@closeModal\",\"@showFutureTrends\",\"@startTrial\"],[[30,0,[\"closeModal\"]],[30,1,[\"openAction\"]],[30,0,[\"startFutureTrendsTrial\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showUpgradeModal\"]],[[[1,\"      \"],[8,[39,10],null,[[\"@closeModal\"],[[30,0,[\"closeUpgradeModal\"]]]],null],[1,\"\\n    \"]],[]],null]],[]]],[1,\"  \"]],[1]]]]],[1,\"\\n\"]],[]],null]],[\"emberDrop\"],false,[\"if\",\"did-insert\",\"perform\",\"shared/ui/button\",\"concat-classes\",\"svg-jar\",\"t\",\"shared/ui/ember-drop\",\"calendar/future-trends/body\",\"calendar/future-trends/try-modal\",\"calendar/future-trends/upgrade-modal\"]]",
    "moduleName": "calendar/components/calendar/future-trends.hbs",
    "isStrictMode": false
  });
  /**
   * Represents the different modal states for the Future Trends component.
   * Using an enum provides better type safety and prevents invalid state transitions.
   */
  var ModalState = /*#__PURE__*/function (ModalState) {
    ModalState["None"] = "none";
    ModalState["Dropdown"] = "dropdown";
    ModalState["TryModal"] = "try-modal";
    ModalState["UpgradeModal"] = "upgrade-modal";
    return ModalState;
  }(ModalState || {});
  /**
   * Future Trends Calendar Component
   *
   * This component provides functionality to display trending hashtags on the calendar view.
   * It handles three main user states:
   * 1. Users with full access can see the trending hashtags immediately
   * 2. Users without access can try a 24-hour trial
   * 3. Users who have exhausted their trial see an upgrade prompt
   *
   * The component manages its state through a single enum rather than multiple boolean flags
   * for better maintainability and to prevent invalid state combinations.
   */
  let FutureTrendsComponent = _exports.default = (_dec = (0, _service.service)('social-listening/future-insights'), (_class = (_class2 = class FutureTrendsComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      _initializerDefineProperty(this, "errors", _descriptor3, this);
      _initializerDefineProperty(this, "segment", _descriptor4, this);
      _initializerDefineProperty(this, "futureInsights", _descriptor5, this);
      _initializerDefineProperty(this, "hasSeenTrialModal", _descriptor6, this);
      _initializerDefineProperty(this, "modalState", _descriptor7, this);
      _initializerDefineProperty(this, "todaysTopHashtagsResponse", _descriptor8, this);
      _initializerDefineProperty(this, "hasTwentyFourHoursPast", _descriptor9, this);
      _defineProperty(this, "loadData", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            this.todaysTopHashtagsResponse = yield this.futureInsights.loadTodaysTopHashtags.perform(this.currentGroupId);
          } catch (error) {
            this.errors.log('Failed to loadData on Calendar::FutureTrends', error);
            this.todaysTopHashtagsResponse = [];
          }
        }
      }), null, "loadData", null));
      this.hasSeenTrialModal = Boolean(this.cache.retrieve(FutureTrendsComponent.TRIAL_CACHE_KEY));
      this.hasTwentyFourHoursPast = this.checkIfTwentyFourHoursPast();
    }
    checkIfTwentyFourHoursPast() {
      const cachedTimestamp = this.cache.retrieve(FutureTrendsComponent.TRIAL_CACHE_KEY);
      if (!cachedTimestamp || typeof cachedTimestamp !== 'string') {
        return false;
      }
      const storedTime = (0, _moment.default)(cachedTimestamp);
      return (0, _moment.default)().isAfter(storedTime);
    }
    get showFutureTrendsOnCalendar() {
      return this.auth.currentAccount?.rolloutFutureInsightsOnCalendar;
    }
    get dateRangeFormatted() {
      try {
        const startDate = (0, _moment.default)();
        const endDate = (0, _moment.default)().add(2, 'weeks');
        const isSameMonth = startDate.month() === endDate.month();
        const from = startDate.format('MMM D');
        const to = isSameMonth ? endDate.format('D') : endDate.format('MMM D');
        return `${from} - ${to}`;
      } catch (error) {
        this.errors.log('Failed to format date range in FutureTrends component', error);
        return 'Next 2 weeks';
      }
    }
    get currentGroupId() {
      return this.auth.currentGroup.get('id');
    }
    get todaysTopHashtags() {
      const sortedHashtags = (this.todaysTopHashtagsResponse ?? []).sort((a, b) => (b.count ?? 0) - (a.count ?? 0));
      const topHashtags = sortedHashtags.slice(0, 3);
      return topHashtags;
    }
    get isLoading() {
      return this.loadData.isRunning;
    }
    get needsUpgrade() {
      return !this.auth.currentAccount?.canFutureInsightsOnCalendar && this.hasSeenTrialModal && this.hasTwentyFourHoursPast;
    }
    get canTryFutureTrends() {
      return !this.auth.currentAccount?.canFutureInsightsOnCalendar && !this.hasSeenTrialModal;
    }

    // Computed properties for template compatibility
    get showFutureTrendsDropdown() {
      return this.modalState === ModalState.Dropdown;
    }
    get showTryFutureTrendsModal() {
      return this.modalState === ModalState.TryModal;
    }
    get showUpgradeModal() {
      return this.modalState === ModalState.UpgradeModal;
    }
    showDropdownOrModal() {
      this.segment.track('opened-future-insights-on-calendar');
      if (this.needsUpgrade) {
        this.modalState = ModalState.UpgradeModal;
        return;
      }
      if (this.canTryFutureTrends) {
        this.modalState = ModalState.TryModal;
        return;
      }
      this.modalState = ModalState.Dropdown;
    }
    closeModal() {
      const trialExpiryTime = (0, _moment.default)().add(FutureTrendsComponent.TRIAL_DURATION_HOURS, 'hours').toISOString();
      this.cache.add(FutureTrendsComponent.TRIAL_CACHE_KEY, trialExpiryTime, {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
      this.modalState = ModalState.None;
      this.hasSeenTrialModal = true;
    }
    startFutureTrendsTrial() {
      this.closeModal();
    }
    closeDropdown() {
      this.modalState = ModalState.None;
    }
    closeUpgradeModal() {
      this.modalState = ModalState.None;
    }
  }, _defineProperty(_class2, "TRIAL_CACHE_KEY", 'future-trends-trial-timestamp'), _defineProperty(_class2, "TRIAL_DURATION_HOURS", 24), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "futureInsights", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "hasSeenTrialModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "modalState", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return ModalState.None;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "todaysTopHashtagsResponse", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hasTwentyFourHoursPast", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "showDropdownOrModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "showDropdownOrModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startFutureTrendsTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "startFutureTrendsTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDropdown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeUpgradeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeUpgradeModal"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FutureTrendsComponent);
});